// extracted by mini-css-extract-plugin
export default {"overflow":"TooltipCell_overflow__OcRBV","ellipsis":"TooltipCell_ellipsis__yg78T"};